module.exports = __webpack_public_path__ + "static/media/restuarantMenu.77026dbb.PNG";